import React from "react";
import classNames from "classnames";
import { RequestStatus } from "../../../../types/mydata";
import { Typography } from "../../../../components/__common/Typography/Typography";

interface StepsProps {
  status: RequestStatus;
}

export const Steps: React.FC<StepsProps> = (props) => {
  const { status } = props;
  const allowedStatuses = [
    RequestStatus.COMPLETED,
    RequestStatus.PROCESSING,
    RequestStatus.REQUESTING,
    RequestStatus.QUEUED,
  ];

  return (
    <>
      {allowedStatuses.includes(status) && (
        <div className="request-details__steps">
          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active:
                status === RequestStatus.REQUESTING ||
                status === RequestStatus.QUEUED,
              prev:
                status !== RequestStatus.REQUESTING &&
                status !== RequestStatus.QUEUED,
            })}
          >
            {status === RequestStatus.REQUESTING ||
            status === RequestStatus.QUEUED
              ? 2
              : ""}
          </Typography>

          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.PROCESSING,
              prev: status === RequestStatus.COMPLETED,
            })}
          >
            {status === RequestStatus.PROCESSING ? 2 : ""}
          </Typography>
          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.COMPLETED,
            })}
          >
            {status === RequestStatus.COMPLETED ? 3 : ""}
          </Typography>
        </div>
      )}
    </>
  );
};
